var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{staticClass:"hr ivu-divider ivu-divider-horizontal ivu-divider-default ivu-divider-dashed",attrs:{"as":"div"}},[_c('Divider',{attrs:{"dashed":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }